import React, { useState, useEffect, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db } from '../../firebase';
import { doc, getDoc, collection, getDocs, query, orderBy } from 'firebase/firestore';
import { FiArrowLeft, FiCalendar, FiMapPin, FiUsers, FiAward } from 'react-icons/fi';

// --- TELJES FORDÍTÁSI TÁBLÁZAT SZINKRONIZÁLVA (CompetitionOffice.js alapján) ---
const translationMap = {
  // Korosztályok
  'mini': 'Mini',
  'gyerek': 'Gyerek',
  'junior': 'Junior',
  'kadet': 'Kadét',
  'fiatal_felnott': 'Fiatal felnőtt',
  'felnott': 'Felnőtt',
  'szenior': 'Szenior',
  'veteran': 'Veterán',

  // 3D kategóriák
  '3d_hdh_bb': 'BB (Barebow)',
  '3d_hdh_bg': 'BG (Fúvócső)',
  '3d_hdh_cb': 'CB (Csigás Barebow)',
  '3d_hdh_crb': 'CRB (Számszeríj)',
  '3d_hdh_cu': 'CU (Scope-os Csigás)',
  '3d_hdh_hu': 'HU (Vadász Csigás)',
  '3d_hdh_ol': 'OL (Olimpiai)',
  '3d_hdh_pbhb': 'PBHB (Pusztai íj (Tradi))',
  '3d_hdh_trlb': 'TRLB (Longbow)',
  '3d_hdh_trrb': 'TRRB (Vadászreflex)',
  '3d_ifaa_bbc': 'BB(C) (Barebow-Csigás)',
  '3d_ifaa_bbr': 'BB(R) (Barebow-Reflex)',
  '3d_ifaa_bhc': 'BH(C) (Vadászijász-Csigás)',
  '3d_ifaa_bhr': 'BH(R) (Vadászijász-Reflex)',
  '3d_ifaa_bl': 'BL (Korlátozott Vadászijász)',
  '3d_ifaa_bu': 'BU (Bowhunter Unlimited)',
  '3d_ifaa_fsc': 'FS(C) (Korl. nyílt o.-Csigás)',
  '3d_ifaa_fsr': 'FS(R) (Korl. nyílt o.-Reflex)',
  '3d_ifaa_fu': 'FU (Korlátlan nyílt osztály)',
  '3d_ifaa_hb': 'HB (Történelmi íj)',
  '3d_ifaa_hbm': 'HB(M) (Történelmi íj modern)',
  '3d_ifaa_lb': 'LB (Longbow)',
  '3d_ifaa_tr': 'TR (Tradicionális reflex)',

  // Terep kategóriák
  'terep_olimpiai': 'OL (Olimpiai)',
  'terep_csigas': 'CU (Scope-os Csigás)',
  'terep_barebow': 'BB (Barebow)',
  'terep_cb': 'CB (Csigás Barebow)',
  'terep_hu': 'HU (Vadász Csigás)',
  'terep_pbhb': 'PBHB (Pusztai íj (Tradi))',
  'terep_trlb': 'TRLB (Longbow)',
  'terep_trrb': 'TRRB (Vadászreflex)',

  // Pálya kategóriák
  'palya_wa_ol': 'R (Olimpiai reflexíj)',
  'palya_wa_cu': 'CU (Scope-os Csigás)',
  'palya_wa_hu': 'HU (Vadász Csigás)',
  'palya_wa_bb': 'B (Barebow)',
  'palya_wa_trrb': 'TRRB (Vadászreflex)',
  'palya_wa_trlb': 'TRLB (Longbow)',
  'palya_wa_pbhb': 'PBHB (Pusztai íj (Tradi))',
  'palya_wa_crb': 'CRB (Számszeríj)',
  'palya_ifaa_fu': 'FU (Freestyle Unlimited)',
  'palya_ifaa_fsr': 'FSR (FSR (Freestyle Ltd Recurve))',
  'palya_ifaa_fsc': 'FSC (FSC (Freestyle Ltd Compound))',
  'palya_ifaa_bbr': 'BBR (Barebow-Reflex)',
  'palya_ifaa_bbc': 'BBC (Barebow-Csigás)',
  'palya_ifaa_bu': 'BU (Bowhunter Unlimited)',
  'palya_ifaa_bl': 'BL (Bowhunter Limited)',
  'palya_ifaa_bhc': 'BHC (Vadászijász-Csigás)',
  'palya_ifaa_bhr': 'BHR (Vadászijász-Reflex)',
  'palya_ifaa_lb': 'LB (Longbow)',
  'palya_ifaa_hb': 'HB (Historical Bow)',
  'palya_ifaa_tr': 'TR (Traditional Bow)',

  // Történelmi kategóriák
  'tortenelmi_pusztai_modern': 'Modern pusztai íj',
  'tortenelmi_pusztai_termeszetes': 'Természetes pusztai íj',
  'tortenelmi_botij': 'Történelmi hosszúíj / Botíj',
  'tortenelmi_vadaszij': 'Hagyományos vadászíj',
  'tortenelmi_szamszerij': 'Történelmi számszeríj',
  'tortenelmi_bb': 'BB (Barebow)',

  // Örömijász kategóriák
  'orom_wa_ol': 'OL (Olimpiai reflexíj)',
  'orom_wa_cu': 'CU (Scope-os Csigás)',
  'orom_wa_hu': 'HU (Vadász Csigás)',
  'orom_wa_cb': 'CB (Csigás Barebow)',
  'orom_wa_bb': 'BB (Barebow)',
  'orom_wa_trrb': 'TRRB (Vadászreflex)',
  'orom_wa_trlb': 'TRLB (Longbow)',
  'orom_wa_pbhb': 'PBHB (Pusztai íj)',
  'orom_wa_crb': 'CRB (Számszeríj)',
  'orom_wa_bg': 'BG (Fúvócső)',

  // Egyéb
  'egyeb_wa_ol': 'OL (Olimpiai reflexíj)',
  'egyeb_wa_cu': 'CU (Scope-os Csigás)',
  'egyeb_wa_hu': 'HU (Vadász Csigás)',
  'egyeb_wa_cb': 'CB (Csigás Barebow)',
  'egyeb_wa_bb': 'BB (Barebow)',
  'egyeb_wa_trrb': 'TRRB (Vadászreflex)',
  'egyeb_wa_trlb': 'TRLB (Longbow)',
  'egyeb_wa_pbhb': 'PBHB (Pusztai íj)',
  'egyeb_wa_crb': 'CRB (Számszeríj)',
  'egyeb_wa_bg': 'BG (Fúvócső)',
  'egyeb_altalanos': 'Egyéb Általános'
};

const getColorForZoneValue = (val) => {
  const v = val?.toString().toUpperCase();
  if (v === '11' || v === 'X') return '#4CAF50';
  if (v === '10' || v === '9') return '#FFD700';
  if (v === '8' || v === '7') return '#F44336';
  if (v === '6' || v === '5') return '#1976D2';
  return '#9E9E9E';
};

const getCompetitionTypeDisplay = (rawType) => {
    const type = rawType?.toLowerCase() || '';
    if (type.includes('3d')) return { label: '3D', color: '#28a745' };
    if (type.includes('palya')) return { label: 'Pálya', color: '#007bff' };
    if (type.includes('orom')) return { label: 'Örömijász', color: '#ffc107' };
    if (type.includes('tortenelmi')) return { label: 'Történelmi', color: '#dc3545' };
    if (type.includes('terep')) return { label: 'Terep', color: '#6d4c41' };
    return { label: rawType || 'Egyéb', color: '#9c27b0' };
};

const ClosedCompetitionLeaderboard = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [competition, setCompetition] = useState(null);
    const [participants, setParticipants] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);

        const fetchResults = async () => {
            setLoading(true);
            try {
                const compDoc = await getDoc(doc(db, "events_closed", id));
                if (!compDoc.exists()) {
                    alert("A verseny nem található!");
                    navigate('/eredmenyek');
                    return;
                }
                setCompetition(compDoc.data());

                const partsSnap = await getDocs(query(collection(db, "events_closed", id, "participants"), orderBy("rank", "asc")));
                const partsData = partsSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setParticipants(partsData);
            } catch (err) {
                console.error("Error fetching results:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchResults();

        return () => window.removeEventListener('resize', handleResize);
    }, [id]);

    const groupedResults = useMemo(() => {
        const groups = {};
        participants.forEach(p => {
            const key = `${p.bowCategory}_${p.ageCategory}_${p.gender}`;
            if (!groups[key]) {
                groups[key] = {
                    bowCategory: p.bowCategory,
                    ageCategory: p.ageCategory,
                    gender: p.gender,
                    members: []
                };
            }
            groups[key].members.push(p);
        });
        return Object.values(groups).sort((a, b) => {
            const nameA = `${translationMap[a.bowCategory?.toLowerCase()] || a.bowCategory} ${translationMap[a.ageCategory?.toLowerCase()] || a.ageCategory}`;
            const nameB = `${translationMap[b.bowCategory?.toLowerCase()] || b.bowCategory} ${translationMap[b.ageCategory?.toLowerCase()] || b.ageCategory}`;
            return nameA.localeCompare(nameB);
        });
    }, [participants]);

    if (loading) return <div style={centerStyle}>Eredménytábla betöltése... 🏹</div>;
    if (!competition) return null;

    return (
        <div style={pageContainerStyle} className="force-light-theme">
            <button onClick={() => navigate('/eredmenyek')} style={backBtnStyle}>
                <FiArrowLeft /> Vissza a listához
            </button>

            <div style={headerCardStyle}>
                <h1 style={titleStyle}>{competition.competitionName}</h1>
                <div style={{ color: '#28a745', fontWeight: 'bold', marginBottom: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                    <FiAward size={24} /> HIVATALOS VÉGEREDMÉNY
                </div>
                <div style={{
                    ...headerDetailsStyle,
                    flexDirection: isMobile ? 'column' : 'row',
                    gap: isMobile ? '10px' : '30px'
                }}>
                    <span><FiCalendar /> {competition.competitionDate}</span>
                    <span style={{
                        color: getCompetitionTypeDisplay(competition.competitionType).color,
                        fontWeight: 'bold',
                        backgroundColor: '#f8f9fa',
                        padding: '2px 8px',
                        borderRadius: '6px',
                        border: `1px solid ${getCompetitionTypeDisplay(competition.competitionType).color}22`
                    }}>
                        {getCompetitionTypeDisplay(competition.competitionType).label}
                    </span>
                    <span><FiMapPin /> {competition.location?.split(',')[0]}</span>
                    <span><FiUsers /> {participants.length} résztvevő</span>
                </div>
            </div>

            <div style={resultsContainerStyle}>
                {groupedResults.map((group, gIdx) => (
                    <div key={gIdx} style={categoryCardStyle}>
                        <h2 style={categoryTitleStyle}>
                            {translationMap[group.bowCategory?.toLowerCase()] || group.bowCategory} - {translationMap[group.ageCategory?.toLowerCase()] || group.ageCategory} - {group.gender}
                        </h2>

                        <div style={{ overflowX: 'auto' }}>
                            <table style={tableStyle}>
                                <thead>
                                    <tr>
                                        <th style={thStyleCenter}>#</th>
                                        <th style={thStyle}>Név</th>
                                        {(competition.scoringValues || ['11', '10', '8', '5', '0']).sort((a,b) => {
                                            const valA = a === 'X' ? 11.5 : (parseInt(a) || 0);
                                            const valB = b === 'X' ? 11.5 : (parseInt(b) || 0);
                                            return valB - valA;
                                        }).map(zone => (
                                            <th key={zone} style={thStyleCenter}>{zone}</th>
                                        ))}
                                        <th style={thStyleRight}>Összesen</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {group.members.map((p, pIdx) => (
                                        <tr
                                            key={pIdx}
                                            style={p.rank <= 3 ? podiumRowStyle(p.rank) : trStyle}
                                            onClick={() => navigate(`/eredmeny/${id}/resztvevo/${p.id}`)}
                                        >
                                            <td style={tdStyleCenter}>
                                                {p.rank === 1 ? '🥇' : p.rank === 2 ? '🥈' : p.rank === 3 ? '🥉' : `${p.rank}.`}
                                            </td>
                                            <td style={tdStyle}>
                                                <div style={{ fontWeight: 'bold' }}>{p.fullName}</div>
                                                <div style={{ fontSize: '0.75rem', color: '#888' }}>{p.club}</div>
                                            </td>
                                            {(competition.scoringValues || ['11', '10', '8', '5', '0']).sort((a,b) => {
                                                const valA = a === 'X' ? 11.5 : (parseInt(a) || 0);
                                                const valB = b === 'X' ? 11.5 : (parseInt(b) || 0);
                                                return valB - valA;
                                            }).map(zone => (
                                                <td key={zone} style={tdStyleCenter}>
                                                    {p.hitZoneCounts?.[zone] || 0}
                                                </td>
                                            ))}
                                            <td style={tdStyleRight}><strong>{p.totalScore} pont</strong></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ))}
            </div>
            <div style={{ height: '80px' }} />
        </div>
    );
};

// --- STÍLUSOK ---
const pageContainerStyle = { padding: '20px', maxWidth: '1000px', margin: '0 auto', backgroundColor: '#f4f6f8', minHeight: '100vh' };
const backBtnStyle = { display: 'flex', alignItems: 'center', gap: '8px', border: 'none', background: 'none', color: '#666', fontWeight: 'bold', cursor: 'pointer', marginBottom: '20px' };
const headerCardStyle = { backgroundColor: '#fff', borderRadius: '15px', padding: '25px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)', marginBottom: '30px', textAlign: 'center', borderTop: '5px solid #b30000' };
const titleStyle = { margin: '0 0 5px 0', color: '#b30000', fontSize: '2rem', fontWeight: '900' };
const headerDetailsStyle = { display: 'flex', justifyContent: 'center', gap: '30px', color: '#666', fontSize: '0.95rem' };
const resultsContainerStyle = { display: 'flex', flexDirection: 'column', gap: '25px' };
const categoryCardStyle = { backgroundColor: '#fff', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' };
const categoryTitleStyle = { margin: '0 0 15px 0', paddingBottom: '10px', borderBottom: '2px solid #eee', color: '#333', fontSize: '1.1rem', fontWeight: 'bold' };
const tableStyle = { width: '100%', borderCollapse: 'collapse' };
const thStyle = { textAlign: 'left', padding: '12px 8px', color: '#888', fontSize: '0.8rem', textTransform: 'uppercase' };
const thStyleCenter = { ...thStyle, textAlign: 'center' };
const thStyleRight = { ...thStyle, textAlign: 'right' };
const tdStyle = { padding: '12px 8px', borderBottom: '1px solid #f0f0f0', fontSize: '0.9rem' };
const tdStyleCenter = { ...tdStyle, textAlign: 'center' };
const tdStyleRight = { ...tdStyle, textAlign: 'right', color: '#b30000' };
const trStyle = { transition: '0.2s' };
const podiumRowStyle = (rank) => ({
    backgroundColor: rank === 1 ? '#fffcf0' : rank === 2 ? '#f8f9fa' : '#fff9f5',
    transition: '0.2s'
});
const centerStyle = { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', color: '#666' };

export default ClosedCompetitionLeaderboard;
